import script from "./userbar.vue?vue&type=script&lang=ts&setup=true"
export * from "./userbar.vue?vue&type=script&lang=ts&setup=true"

import "./userbar.vue?vue&type=style&index=0&id=108bf127&lang=scss&scoped=true"

import exportComponent from "E:\\phpstudy_pro\\WebWWW\\inspectionSystem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-108bf127"]])

export default __exports__